module.exports = __webpack_public_path__ + "img/decrease.fbcd7742.svg";